import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { ListStepsParams } from 'src/app/core/steps.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY', // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'DD/MM/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-steps-filter-dialog',
  templateUrl: './steps-filter-dialog.component.html',
  styleUrls: ['./steps-filter-dialog.component.scss'],

  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
  ],
})
export class StepsFilterDialogComponent {
  steps_filter_from_group: FormGroup = this.form_service.steps_filter_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(
    private dialog_ref: MatDialogRef<StepsFilterDialogComponent>,
    private form_service: FormService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {}

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onApplyFiltersClick(): void {
    if (this.isFormValid()) {
      const order_id: string | '' = this.steps_filter_from_group.get(this.form_service.order_id_label)?.value;
      const qinetic_id: string | '' = this.steps_filter_from_group.get(this.form_service.qinetic_id_label)?.value;
      const steps_id: string | '' = this.steps_filter_from_group.get(this.form_service.steps_id_label)?.value;

      const created_from_text: string = this.steps_filter_from_group.get(this.form_service.created_from_label)?.value;
      const created_to_text: string = this.steps_filter_from_group.get(this.form_service.created_to_label)?.value;
      const created_from: number = new Date(created_from_text).getTime();
      const created_to: number = new Date(created_to_text).getTime();

      const due_date_from_text: string = this.steps_filter_from_group.get(this.form_service.due_date_from_label)?.value;
      const due_date_to_text: string = this.steps_filter_from_group.get(this.form_service.due_date_to_label)?.value;
      const due_date_from: number = new Date(due_date_from_text).getTime();
      const due_date_to: number = new Date(due_date_to_text).getTime();

      const params: ListStepsParams = {
        order_id: order_id == '' ? undefined : order_id,
        qinetic_id: qinetic_id == '' ? undefined : qinetic_id,
        steps_id: steps_id == '' ? undefined : steps_id,
        created_from: !created_from_text || created_from_text == '' ? undefined : created_from,
        created_to: !created_to_text || created_to_text == '' ? undefined : created_to,
        due_date_from: !due_date_from_text || due_date_from_text == '' ? undefined : due_date_from,
        due_date_to: !due_date_to_text || due_date_to_text == '' ? undefined : due_date_to,
      };
      this.dialog_ref.close({ params });
    }
  }

  onClearFiltersClick(): void {
    this.steps_filter_from_group.reset();
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.steps_filter_from_group);
  }
}
